var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopSplashPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 308 560",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "top_splash_placeholder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Top"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145,
    y: 187,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "186 175.81 186 228 133.3 228 121.18 240 198 240 198 163.93 186 175.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "130 219 130 172 177 172 192 157 115 157 115 234 130 219"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopSplashPlaceholder);
export default __webpack_public_path__ + "static/media/top_splash_placeholder.01a6aefba59f63e30ebe5fc126159e94.svg";
export { ForwardRef as ReactComponent };